module.exports = __webpack_public_path__ + "static/img/warriorhead.6cb20ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/warriorhead.svg
// module id = 10
// module chunks = 0